import {
  LoadingManager,
  TextureLoader,
  MeshPhysicalMaterial,
  LinearFilter,
  DoubleSide,
  VideoTexture,
  CanvasTexture
} from "three";
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'

class Assets {
  manager = new LoadingManager();
  textureLoader = new TextureLoader(this.manager);
  gltfLoader = new GLTFLoader(this.manager);
  path;
  logo = null;
  logoPng = null;
  menuTransition = []
  menuImages = []
  menuVideos = []
  defaultTexture = null;

  constructor() {
    const canvas = document.createElement('canvas');
    canvas.width = 1;
    canvas.height = 1;

    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#010101'; 
    ctx.fillRect(0, 0, 1, 1);

    this.defaultTexture = new CanvasTexture(canvas);
    this.defaultTexture.minFilter = LinearFilter;
  }
  initialize() {
    const menuImages = document.body.querySelectorAll(".cinetic-creative-core-menu .wp-block-cinetic-creatives-blocks-adjacent-posts img");
    menuImages.forEach((image) => {
        const texture = this.textureLoader.load( image.getAttribute("src"));
        texture.minFilter = LinearFilter
        this.menuImages.push(texture)
    })

    const menuVideos = document.body.querySelectorAll(".cinetic-creative-core-menu .wp-block-cinetic-creatives-blocks-adjacent-posts article");
    menuVideos.forEach((item, i) => {
        let texture = null
        const video = item.querySelector("video")
        if (video) {
            texture = new VideoTexture(video)
            video.addEventListener('loadeddata', () => {
                texture.needsUpdate = true; 
                video.play()
            });
            video.play()
        } else {
            texture = this.menuImages[i] || this.defaultTexture;
        }

        const categories = item.dataset.categories.split(" ");
        texture.categories = categories
        
        this.menuVideos.push(texture)
    })

    this.logoPng = this.textureLoader.load(`/wp-content/themes/cinetic/assets/models/logo.png`)
    this.perlin = this.textureLoader.load(`/wp-content/themes/cinetic/assets/models/perlin.png`)
    this.glitch = this.textureLoader.load(`/wp-content/themes/cinetic/assets/models/glitche.jpeg`)

    for (let i = 0; i <= 28; i++) {
        this.menuTransition[i] = this.textureLoader.load(`/wp-content/themes/cinetic/assets/models/menu/Transition--export_${i}.jpg`)
    }

    const modelPath = '/wp-content/themes/cinetic/assets/models/logo.glb';
    this.gltfLoader.load(
        modelPath,
        (gltf) => {
            this.logo = gltf.scene;
        
            this.logo.scale.set(5, 5, 5);
            
            const material = new MeshPhysicalMaterial( {
                side: DoubleSide,
                transmission: 1.0,
                thickness: 0.01,
                metalness: 0.0,
                roughness: 0.0,
            } )

            this.logo.traverse((children) => {
                if (children.isMesh) {
                    children.position.z =  -0.0018215351738035679
                    children.material = material
                }
            })
            console.log("Model loaded successfully!", gltf);
        },
        (xhr) => {
            console.log((xhr.loaded / xhr.total * 100) + '% loaded');
        },
        (error) => {
            console.error('An error happened loading the GLB:', error);
        }
    );
  }
}

export default new Assets();
